import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'contacts',
  templateUrl: './contacts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryContactsComponents implements OnInit {
  @Input() data;
  @Output() dContactsEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dContactsEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dContactsEmitter.emit({ status: 'backward' });
  }
}
